<p-toast></p-toast>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  header="Gestión de Miembros del Equipo"
  (onHide)="onCloseModal()"
  styleClass="team-members-dialog"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <i class="pi pi-users modal-icon"></i>
      <div class="header-info">
        <span class="team-name">{{ team!.name || ''}}</span>
        <span class="category-info" *ngIf="category">{{ category.name }} - {{ category.branch }}</span>
      </div>
    </div>
  </ng-template>

  <div class="team-members-content">
    <div class="members-header">
      <h4>Miembros del Equipo</h4>
      <p-tag 
        [value]="currentMembers.length + ' miembros'" 
        severity="info">
      </p-tag>
    </div>
    
    <div class="members-section" *ngIf="currentMembers.length > 0; else noCurrentMembers">
            <p-table 
              [value]="currentMembers" 
              dataKey="memberId"
              styleClass="lpa-modal-table"
              responsiveLayout="stack"
              [breakpoint]="'960px'"
              [rowHover]="true"
              [rows]="currentMembers.length"
              [rowsPerPageOptions]="[currentMembers.length,5,10,20]"
              [paginator]="currentMembers.length > 10"
              currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
              [showCurrentPageReport]="currentMembers.length > 10"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th class="table__header-title">Miembro</th>
                  <th class="table__header-title">Documento</th>
                  <th class="table__header-title">Edad</th>
                  <th class="table__header-title">Género</th>
                  <th class="table__header-title">Nivel</th>
                  <th class="table__header-title">Contacto</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-member>
                <tr>
                  <td>
                    <span class="p-column-title font-bold">Miembro</span>
                    <div class="member-info">
                      <div class="member-avatar">
                        <img 
                          *ngIf="member.picture; else defaultAvatar"
                          [src]="member.picture" 
                          [alt]="member.name"
                          class="avatar-img"
                        />
                        <ng-template #defaultAvatar>
                          <i class="pi pi-user default-avatar"></i>
                        </ng-template>
                      </div>
                      <div class="member-details">
                        <strong>{{ member.name }} {{ member.lastName }}</strong>
                        <div class="role-info">
                          <span class="role-text">{{ member.rol }}</span>
                          <span
                            *ngIf="isPlayerRole(member) && getPlayerNumber(member)"
                            class="player-number">
                            #{{ getPlayerNumber(member) }}
                          </span>
                          <p-tag
                            *ngIf="hasCategoryAgeError(member)"
                            value="Ajuste de Categoría"
                            severity="danger"
                            icon="pi pi-exclamation-triangle"
                            pTooltip="Este deportista no cumplía la edad mínima al inicio del torneo. Debe ser removido."
                            tooltipPosition="top"
                            styleClass="age-error-tag-inline">
                          </p-tag>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title font-bold">Documento</span>
                    <div class="document-info">
                      <span class="id-number">{{ member.idType }} {{ member.idNumber }}</span>
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title font-bold">Edad</span>
                    <span class="age">{{ getMemberAge(member.birthDay) }} años</span>
                  </td>
                  <td>
                    <span class="p-column-title font-bold">Género</span>
                    <p-tag 
                      [value]="getGenderLabel(member.gender)" 
                      [severity]="member.gender === 'M' ? 'info' : member.gender === 'F' ? 'warning' : 'secondary'">
                    </p-tag>
                  </td>
                  <td>
                    <span class="p-column-title font-bold">Nivel</span>
                    <p-tag [value]="member.nivel" severity="secondary"></p-tag>
                  </td>
                  <td>
                    <span class="p-column-title font-bold">Contacto</span>
                    <div class="contact-info">
                      <div *ngIf="member.contactInformation.email">
                        <i class="pi pi-envelope"></i>
                        <span>{{ member.contactInformation.email }}</span>
                      </div>
                      <div *ngIf="member.contactInformation.mobile">
                        <i class="pi pi-phone"></i>
                        <span>{{ member.contactInformation.mobile }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

    <ng-template #noCurrentMembers>
      <div class="no-members-message">
        <i class="pi pi-info-circle"></i>
        <h5>Este equipo no tiene miembros registrados</h5>
      </div>
    </ng-template>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <p-button
        label="Cerrar"
        icon="pi pi-times"
        (onClick)="onCloseModal()"
        severity="secondary"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>